@if (isLoading) {
  <div class="spinner-overlay">
    <div class="spinner-container">
      <div class="spinner"></div>
      @if (message) {
        <p class="spinner-message">{{ message }}</p>
      }
    </div>
  </div>
}
